import {Base} from "@/api/Base"

export class OtherEdit extends Base {
    path = "other/edit"
}